define('webshopProductsDetailBodyUrlsV1DomainView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'settings',
  'buttonView',
  'modalsAlertView',
  'template!webshopProductsDetailBodyUrlsV1DomainView'
], function (
  App,
  Module,
  Marionette,
  _,
  Settings,
  ButtonView,
  AlertView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'domain-view',

    modelEvents: {
      'change': 'render'
    },

    serializeData: function () {
      var data = {};
      data.mode = Settings.configValue('webshop.urls.mode');
      data.domain = this.model.get('domain');
      data.url = this.model.get('url');
      return data;
    }
  });
});
